import React from 'react';

interface IProps {
  getRadioProps: any;
}

export const radioButtonContext = React.createContext<IProps>(null!);
